import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  input: {
    display: 'none',
  },
  icon: {
    fill: theme.palette.primaryPure,
    padding: 0,
  },
}));

export default useStyles;
